import * as React from 'react';
import { ActionAfterViewObserver } from '@cian/action-after-viewed-component';

import { MortgageBrokerBanner } from './components/MortgageBrokerBanner';
import { trackMortgageBrokerBannerClick, trackMortgageBrokerBannerShow } from './tracking';
import { useIsMortgageBrokerBannerAvailable } from '../../hooks/useIsMortgageBrokerBannerAvailable';
import { useApplicationContext } from '../../utils/withApplicationContext';

const URL_QUERY = '?cian_source=complex_card';

/**
 * Баннер сервиса "Ипотечный брокер" (Циан.Ипотека для профи)
 */
export const MortgageBrokerBannerContainer = () => {
  const { config } = useApplicationContext();
  const isAvailable = useIsMortgageBrokerBannerAvailable();
  const mortgageMiniCalculatorEnabled = config.get<boolean>('Newbuilding.MortgageMiniCalculator.Enabled');

  if (!isAvailable || mortgageMiniCalculatorEnabled) {
    return null;
  }

  const promoUrl = config.get<string>('mortgage-broker-application-frontend.promoUrl') + URL_QUERY;
  const calculatorUrl = config.get<string>('mortgage-broker-calculator-frontend.baseUrl') + URL_QUERY;

  return (
    <ActionAfterViewObserver callback={trackMortgageBrokerBannerShow} percentVisible={0.8} triggerOnce>
      <MortgageBrokerBanner
        promoUrl={promoUrl}
        calculatorUrl={calculatorUrl}
        onLinkClick={trackMortgageBrokerBannerClick}
      />
    </ActionAfterViewObserver>
  );
};

MortgageBrokerBannerContainer.displayName = 'MortgageBrokerBannerContainer';
